import axios from "axios";
import { Toast } from "vant";
import { filterRegionShop } from "@/utils/operate";

// 创建axios实例
const service = axios.create({
  baseURL: "http://api.abi-inbev.com/index.php/api",
  // baseURL: "/dev-api/api",
  timeout: 20000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

const whiteList = ["/index/get_OpenIdAccess_list", "/login/index"];
// response 拦截器
service.interceptors.response.use(
  (response) => {
    console.log(response);

    const { status, data: res, config } = response;
    if (status !== 200) {
      return Promise.reject("error");
    }
    const { error_code, error_msg, data } = res;
    if (error_code === 0) {
      const rows = whiteList.includes(config.url)
        ? data.rows
        : filterRegionShop(data.rows);
      // const rows = data.rows;
      return Promise.resolve(rows);
    } else {
      Toast.fail(error_msg);
      return Promise.reject("error");
    }
  },
  (error) => {
    console.log("err：", Object.keys(error), error.response);
    Toast.fail(error);
    return Promise.reject(error);
  }
);

export default service;
